<template>
  <div
    v-if="data"
    class="goods-item-container">
    <div class="exh_image">
      <a
        :title="data.exhibitionName"
        :href="`/exhibition/${data.exhibitionId || data.id}.html`"
        target="_blank">
        <NuxtImg
          :alt="data.exhibitionName"
          :src="coverImg(data.pic || data.logo)"
          class="cover"
          loading="lazy"
          rel="nofollow,noindex" />
      </a>
      <img
        v-if="isHot"
        alt="hot"
        class="hot-icon"
        src="~/assets/icon/hot.png" />
    </div>
    <div class="exh-info-wrap">
      <div class="name_remind">
        <i
          v-if="data.tag"
          :data-tag="data.tag"
          class="tag">
          <template v-if="data.tag == 1">热门</template>
          <template v-if="data.tag == 2">推荐</template>
          <template v-if="data.tag == 3">精选</template>
        </i>
        <!-- <nuxt-link
          :to="`/exhibition/${data.exhibitionId || data.id}.html`"
          tag="h2"
          @click="handleToDetail(data.exhibitionId || data.id)"
        >
          {{ data.exhibitionName }}
        </nuxt-link> -->
        <!-- @click="handleToDetail(data.exhibitionId || data.id)" -->
        <h2 :style="{ 'text-indent': data.tag ? '42px' : ' 0' }">
          <a
            :href="`/exhibition/${data.exhibitionId || data.id}.html`"
            target="_blank">
            {{ data.exhibitionName }}
          </a>
        </h2>
      </div>
      <div class="En">
        <div class="En_name">
          <!--          <nuxt-link :title="data.exhibitionEnglishName" :to="`/exhibition/${data.exhibitionId || data.id}.html`" target="_blank">-->
          {{ data.exhibitionEnglishName }}
          <!--          </nuxt-link>-->
        </div>
      </div>
      <div class="time_remind">
        <div
          v-if="data.dynamic == 1"
          class="dynamic-tag">
          {{ $t('exhibition.postponed') }}
        </div>
        <div
          v-if="data.dynamic == 3"
          class="dynamic-tag">
          {{ $t('exhibition.cancelled') }}
        </div>
        <div
          v-if="data.dynamic == 5"
          class="dynamic-tag">
          {{ $t('exhibition.notNewTime') }}
        </div>
        <time :class="data.dynamic == 3 || data.dynamic == 5 ? 'line' : ''">
          <template v-if="isLogin">
            <template v-if="data.dynamic == 0">{{ data.lunchTime }}</template>
            <template v-else>{{ data.changeTime || data.lunchTime }}</template>
          </template>
          <template v-else>
            {{
              data.changeTime ? data.changeTime.substring(0, 7) : data.lunchTime.substring(0, 7)
            }}...
            <span
              @click="clickLogin"
              style="font-size: 14px; cursor: pointer">
              {{ $t('exhibitionDetail.viewTime') }}
            </span>
          </template>
        </time>
      </div>
      <div class="scale-remind">
        <div>
          {{ data.scale }}
        </div>
        <div>{{ $t('exhibition.visitorCount') }}:{{ numFormat(data.audience) }}</div>
      </div>
      <div class="btn_remind">
        <div class="hot">
          <img
            alt="hot"
            rel="nofollow,noindex"
            src="~/assets/icon/fire.png" />
          <div class="hot_num">{{ numFormat(data.hot) }}{{ $t('exhibition.visitorViews') }}</div>
        </div>
        <template v-if="data.dynamic === 0">
          <div
            v-if="data.countDays > 0"
            class="distance"
            style="font-size: 14px">
            {{ $t('exhibition.daysToOpen') }}
            <span style="font-size: 16px">{{ data.countDays }}</span>
            {{ $t('exhibition.day') }}
          </div>
          <div
            v-else-if="data.countDays === 0"
            class="distance"
            style="font-size: 14px">
            {{ $t('exhibition.ongoing') }}
          </div>
          <div
            v-else
            class="distance"
            style="font-size: 14px">
            {{ $t('exhibition.nextEditionUpdate') }}
          </div>
        </template>
      </div>
      <div
        v-if="data.exhibitionFollows && data.exhibitionFollows.length > 0"
        class="avatar_div">
        <div class="avatar-list">
          <div
            class="avatar_box">
            <NuxtImg
              :src="getWebp(`https://dcdn-jufair.jufair.com/jufair/exhibition-follower-avatar/${data.exhibitionId}.png`)"
              :alt="$t('personal.avatar')"
              class="set-img"
              loading="lazy"
               @error="handleAvatarError"
              :title="$t('personal.avatar')" />
          </div>
        </div>
        <div class="avatar_name">
          {{ data.exhibitionFollows.length ? data.exhibitionFollows[0].companyName : '' }}
        </div>
      </div>
      <div
        v-if="false"
        class="price-wrap">
        <div
          v-if="data.spacePrice && data.spacePrice != ' '"
          class="price-value">
          <span>{{ $t('exhibition.standardBooth') }}: {{ data.spacePrice }}</span>
        </div>
        <div
          v-if="data.boothPrice && data.boothPrice != ' '"
          class="price-value">
          <span>{{ $t('exhibition.bareSpace') }}: {{ data.boothPrice }}</span>
        </div>
      </div>
      <div class="btn-like-remind">
        <FairTag
          :exhibition-id="data.exhibitionId || data.id"
          :smallTag="true"
          :tag-num="3" />
        <div
          class="btn-like"
          @click="handleFocus(data.exhibitionId)">
          {{ isFocus ? $t('exhibition.subscribed') : $t('exhibition.subscribe') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { defineProps, onMounted, ref } from 'vue'
  import FairTag from './fairTag.vue'
  import { ResponseCode } from '~/utils/constant'
  import { getXOssProcess } from '~/utils/common'
  import { useRoute } from 'vue-router'
  import { fetchExhibitionFollow } from '~/api/exhibition'

  const props = defineProps({
    data: {
      type: Object,
      default: () => ({})
    },
    isHot: {
      type: Boolean,
      default: false
    },
    smallTag: {
      type: Boolean,
      default: false
    },
    industryId: {
      type: Number,
      default: 0
    }
  })

  const isFocus = ref(false)
  const userStore = useUserStore()
  const route = useRoute()
  const { t: $t } = useI18n()
  const token = useCookie('access_token')

  onMounted(() => {
    isFocus.value = props.data.isFocus
  })
  const globalStore = useGlobalStore()
  const isLogin = computed(() => globalStore.isLogin)
  const loginModal = computed(() => globalStore.loginModal)
  const handleToDetail = (id: any) => {
    window.open(`/exhibition/${id}.html`)
  }

  const shouldLogin = () => {
    if (!token) {
      // Show login modal
      return false
    }
    return true
  }
  const clickLogin = () => {
    if (!isLogin.value) {
      return loginModal?.value.open()
    }
  }

  const handleFocus = async (id: string) => {
    userStore.setOrigins(location.origin + route.fullPath)
    userStore.setAction(4)
    userStore.setIndustryId(props.industryId)

    if (shouldLogin()) {
      const res = await fetchExhibitionFollow({ exhibitionId: id })
      if (res?.code === ResponseCode.SUCCESS) {
        isFocus.value = !isFocus.value
      }
    }
  }

  const coverImg = (value: string) => {
    try {
      return getWebp(JSON.parse(value)[0])
    } catch (e) {
      return getWebp(value)
    }
  }
</script>
<style lang="less" scoped>
  .goods-item-container {
    width: 588px;
    //height: 320px;
    background: #fff;
    border-radius: 6px;
    padding: 17px 15px;
    margin-bottom: 14px;
    display: flex;

    &:hover {
      .exh_image {
        .cover {
          transform: scale(1.2);
        }
      }
    }

    .exh-info-wrap {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      width: calc(100% - 212px);
    }

    .exh_image {
      width: 200px;
      height: 156px;
      border-radius: 4px;
      flex-shrink: 0;
      margin: 0 12px 0 0;
      // border: 1px solid #d9d9d9;
      //margin-bottom: 13px;
      position: relative;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 200px;
        height: 200px;
        border-radius: 4px;
        transition: all 0.3s;
        object-fit: contain;
      }

      .hot-icon {
        width: 32px;
        height: 20px;
        position: absolute;
        top: 0;
        left: 0;
      }
    }

    .En {
      display: flex;
      margin-bottom: 8px;

      .En_name {
        font-size: 16px;
        //font-weight: bold;
        //color: @app-color;
        flex: 1;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        a {
          //color: @app-color;
        }
      }
    }

    .name_remind {
      position: relative;
      font-size: 18px;
      color: #333;
      letter-spacing: 1px;
      margin-bottom: 5px;
      word-break: break-all;
      display: flex;
      align-items: center;
      h2 {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      a {
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      h2 {
        font-size: 18px;
        font-weight: normal;
        cursor: pointer;
      }

      .tag {
        display: inline-block;
        position: absolute;
        top: 0;
        left: 0;
        // display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 20px;
        line-height: 19px;
        font-style: normal;
        font-size: 13px;
        border-radius: 4px;
        padding: 0 4px;
        padding-left: 6px;
        color: #fff;
        margin-right: 2px;
        text-align: center;
        cursor: pointer;
      }

      .tag[data-tag='1'],
      .tag[data-tag='热门'] {
        background: linear-gradient(#ff6337, #ff381a);
      }

      .tag[data-tag='2'],
      .tag[data-tag='推荐'] {
        background: linear-gradient(#39dd80, #1cb84a);
      }

      .tag[data-tag='3'],
      .tag[data-tag='精选'] {
        background: linear-gradient(#37b0fe, #1d7cfe);
      }
    }

    .time_remind {
      font-size: 17px;
      color: #333;
      margin-bottom: 20px;
      // white-space: nowrap;
      // text-overflow: ellipsis;
      // overflow: hidden;
      // word-break: break-all;
      display: flex;
      // justify-content: space-between;
      align-items: center;

      time {
        font-family:
          PingFangSC-Semibold,
          PingFang SC,
          sans-serif;
        font-weight: bold;
      }

      .line {
        text-decoration: line-through;
      }

      .dynamic-tag {
        font-size: 14px;
        background: #faad14;
        color: #fff;
        margin-right: 4px;
        padding: 2px 4px;
        border-radius: 4px;
      }
    }

    .hot {
      display: flex;
      align-items: center;

      img {
        height: 15px;
        width: auto;
        margin-right: 5px;
      }

      .hot_num {
        font-size: 16px;
        color: #333;
        white-space: nowrap;
      }
    }

    .btn_remind {
      display: flex;
      align-items: center;
      margin-top: 10px;

      .distance {
        font-size: 16px;
        color: #333;
        margin-left: auto;

        span {
          color: #ff8600;
          font-size: 16px;
          font-weight: bold;
        }
      }
    }

    .scale-remind {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
    }

    .avatar_div {
      display: flex;
      align-items: center;

      .avatar-list {
        margin-top: 20px;
        display: flex;
        width: 200px;

        .avatar_box {
          margin-left: -8px;

          .set-img {
            width: 130px;
            height: 26px;
            object-fit: contain;
          }

          &:first-child {
            margin-left: 0;
          }
        }
      }

      .avatar_name {
        // width: 140px;
        font-size: 14px;
        margin-top: 20px;
        // flex: 1;
        text-align: center;
        overflow: hidden; /* 隐藏溢出内容 */
        text-overflow: ellipsis; /* 使用省略号表示溢出的文本 */
        white-space: nowrap; /* 防止文本换行 */
      }
    }

    .price-wrap {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin: 6px 0;

      .price-value {
        display: inline-flex;
        border: 1px solid #d7d7d7;
        padding: 2px 4px;
        margin: 4px 0 0;
        border-radius: 4px;
        max-width: 100%;

        span {
          display: inline-block;
          font-size: 14px;
          width: 100%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }

    .btn-like-remind {
      display: flex;
      margin: 20px 0 0 0;

      .btn-like {
        margin-left: auto;
        font-size: 14px;
        color: #fff;
        border: 1px solid #eee;
        padding: 6px 16px;
        cursor: pointer;
        background: #0086f6;
        border-radius: 6px;
        font-family:
          PingFangSC-Medium,
          PingFang SC,
          sans-serif;
      }
    }
  }
</style>
